if (!customElements.get('header-drawer')) {
  customElements.define('header-drawer', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.root = this.querySelector('details');
      if (!this.root) return;
      this.querySelectorAll('details').forEach(details => {
        details.addEventListener('toggle', () => {
          details.classList.toggle('menu-opening', details.open);
          details.querySelector('summary')?.setAttribute('aria-expanded', String(details.open));
          if (details === this.root) {
            document.body.style.overflow = details.open ? 'hidden' : this.previousOverflow || '';
            if (details.open) this.querySelector('.menu-drawer__close-menu-btn')?.focus();
          }
        });
      });
      this.root.querySelector('summary').addEventListener('click', () => {
        if (!this.root.open) this.previousOverflow = document.body.style.overflow;
      });
      this.querySelectorAll('.menu-drawer__close-menu-btn, .menu-drawer__close-button').forEach(button => {
        button.addEventListener('click', event => {
          event.preventDefault();
          const details = button.classList.contains('menu-drawer__close-menu-btn') ? this.root : button.closest('details');
          if (details) { details.open = false; details.querySelector('summary')?.focus(); }
        });
      });
      this.addEventListener('keydown', event => {
        if (!this.root.open) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          this.root.open = false;
          this.root.querySelector('summary').focus();
        }
        if (event.key === 'Tab') {
          const items = [...this.querySelector('#menu-drawer').querySelectorAll('a, button, summary, input, select, [tabindex="0"]')].filter(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden' && !el.disabled);
          if (!items.length) return;
          if (event.shiftKey && document.activeElement === items[0]) { event.preventDefault(); items.at(-1).focus(); }
          if (!event.shiftKey && document.activeElement === items.at(-1)) { event.preventDefault(); items[0].focus(); }
        }
      });
    }
    disconnectedCallback() {
      if (this.root?.open) document.body.style.overflow = this.previousOverflow || '';
    }
  });
}
